import React from 'react';

function Footer() {
  const lastUpdated = process.env.REACT_APP_LAST_UPDATED
    ? new Date(process.env.REACT_APP_LAST_UPDATED).toLocaleDateString('en-GB', { year: 'numeric', month: 'long' })
    : null;

  return (
    <footer style={{
      textAlign: 'center',
      padding: '40px 0',
      color: 'var(--text-dim)',
      fontSize: 14,
      marginTop: 'auto',
      borderTop: '1px solid var(--border)'
    }}>
      <p>&copy; {new Date().getFullYear()} Salvatore Lo Sardo. All rights reserved.</p>
      {lastUpdated && (
        <p style={{ marginTop: 6, fontSize: 12, opacity: 0.6 }}>Last updated {lastUpdated}</p>
      )}
    </footer>
  );
}

export default Footer;
